import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import "./index.css";

export function App() {
  return (
    <AuthProvider>
      <LandingPage />
    </AuthProvider>
  );
}

export default App;
